import { render, staticRenderFns } from "./goldTable.vue?vue&type=template&id=71788361&"
import script from "./goldTable.vue?vue&type=script&lang=js&"
export * from "./goldTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports